export default "__VITE_ASSET__B9E5dzSm__"